import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';
import { SettlementStatisticsConverterDetailExpenditurePage } from '@/pages/settlement-statistics-converter/ui/SettlementStatisticsConverterDetailExpenditurePage';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

/**
 * 歳出コード振り結果の検索パラメータスキーマ
 */
export const expenditureSearchSchema = paginationSchema.extend({
  query_store_id: z.string().optional(),
  amount_unit: z.enum(amountUnitValues).optional(),
});

/**
 * 決算統計コンバーター結果詳細ルート（歳出コード振り結果タブ）
 */
export const Route = createFileRoute(
  '/_protected/settlement-statistics-converter/$resultId/expenditure',
)({
  component: () => <SettlementStatisticsConverterDetailExpenditurePage />,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: expenditureSearchSchema,
      defaultValues: undefined,
    }),
});
